export const Constants = {
  LCM: 27720, //LCM of numbers from 1  to 12
  PAGE_SCALING_FACTOR: 0.95,
};
